import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";
import { IGame, ILeagueSchedule } from "../../types/api";

import "../../assets/css/majorybl/pages/leagues.scss";
import { getLeagueSchedule } from "../../lib/api";
import Schedule from "../../components/Schedule";
import { store } from "../..";
import {
    leagueManagementActions,
    selectSelectedLeague,
} from "../../features/leaguemgmt/leagueManagementSlice";
import { clubhouseActions } from "../../features/clubhouse/clubhouseSlice";

export const loader = async ({ params }: any) => {
    const leagues = store.getState().leaguemanagement.leagues;

    !leagues.length &&
        (await store.dispatch(leagueManagementActions.getLeagues()));

    const { schedule } = await getLeagueSchedule(params.leagueId);
    let league = selectSelectedLeague(store.getState());

    if (!league) {
        store.dispatch(
            leagueManagementActions.setSelectedLeague(
                parseInt(params.leagueId),
            ),
        );
    }

    store.dispatch(clubhouseActions.setSelectedTeam(undefined));
    league = selectSelectedLeague(store.getState());

    const header = league
        ? `${league.ageLevel}${
              league.designation ? ` ${league.designation}` : ""
          }${league.direction ? ` ${league.direction}` : ""} Playoff Schedule`
        : "League Playoff Schedule";

    return {
        schedule,
        header,
    };
};

const LeaguePlayoffSchedule = (): React.JSX.Element => {
    const { schedule: loadedSchedule } = useLoaderData() as {
        schedule: ILeagueSchedule;
    };
    const [schedule, setSchedule] = useState<IGame[]>(
        loadedSchedule?.games || [],
    );

    return (
        <div data-testid="leagueScheduleContent">
            <Container fluid="xs">
                <Row>
                    <Col>
                        {schedule ? (
                            <Schedule
                                schedule={schedule?.filter(
                                    g => g.isPlayoff === 1,
                                )}
                                showButtons={true}
                                setSchedule={setSchedule}
                                scheduleType="league"
                            />
                        ) : (
                            <h2>No scheduled games</h2>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LeaguePlayoffSchedule;
